import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store/store";

// axios
import axiosClient from "@/plugins/axios.js"

import BootstrapVue3 from 'bootstrap-vue-3';
import vClickOutside from "click-outside-vue3"
import VueFeather from 'vue-feather';
import Toast from "vue-toastification";
const toastOptions = {
  // You can set your default options here
};

import Slider from "@vueform/slider";
import flatPickr from "vue-flatpickr-component";
import Multiselect from '@vueform/multiselect'
import Swal from 'sweetalert2/dist/sweetalert2.js'
window.Swal = Swal

import '@/assets/scss/config/app.scss';

// Filters
import filters from '@/../../shared_resources/js/filters.js'

// Mixins
import mixins from '@/../../shared_resources/js/mixins.js'
import { vMaska } from "maska"

// Register Global Components
import registerGlobalComponents from '@/../../shared_resources/js/global-components.js';

const app = createApp(App)
          .mixin(mixins)
          .use(store)
          .use(router)
          .use(BootstrapVue3)
          .use(Toast, toastOptions)
          .component(VueFeather.type, VueFeather)
          .use(vClickOutside)
          .component('Slider', Slider)
          .component('flatPickr', flatPickr)
          .component('Multiselect', Multiselect)
          .directive("maska", vMaska)
          .use(filters);
app.config.globalProperties.$http = axiosClient;

registerGlobalComponents(app);
app.mount('#app')



    